var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVadeMecum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4312D822-5261-4DAD-8045-920C085B757E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.1-home-aba/carreira-juridica",
    transform: "translate(-24.000000, -858.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-principal",
    transform: "translate(24.000000, 232.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-vade-mecum",
    transform: "translate(0.000000, 626.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    fillOpacity: 0,
    fill: "#F5F5F5",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "book-(1)-2",
    transform: "translate(1.000000, 1.000000)",
    fill: "#1717CE",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9877458,20.4116939 C21.9876545,20.4114242 21.9876089,20.4111545 21.9875176,20.4108849 L16.5078864,0.266317956 C16.4556856,0.0750265527 16.2561906,-0.038687557 16.0618063,0.0121017489 L11.124261,1.31518454 C11.0565459,1.33496091 10.9963141,1.37415407 10.9512315,1.42773005 L10.9512315,0.655732599 C10.9512315,0.457159897 10.7877844,0.296162292 10.5861905,0.296162292 L0.365041051,0.296162292 C0.163447131,0.296162292 0,0.457159897 0,0.655732599 L0,21.5108104 C0,21.7093831 0.163447131,21.8703807 0.365041051,21.8703807 L10.5861905,21.8703807 C10.7877844,21.8703807 10.9512315,21.7093831 10.9512315,21.5108104 L10.9512315,2.06812477 L16.3458082,21.9002251 C16.3886093,22.0574022 16.5332111,22.1666667 16.6984379,22.1666667 C16.7299683,22.1664419 16.7613618,22.1623518 16.7918884,22.1544413 L21.7283385,20.8513585 C21.9232248,20.8005242 22.0393535,20.6036595 21.9877458,20.4116939 Z M5.11057472,21.1512401 L0.730082103,21.1512401 L0.730082103,1.01530291 L5.11057472,1.01530291 L5.11057472,21.1512401 Z M10.2211494,21.1512401 L5.84065682,21.1512401 L5.84065682,1.01530291 L10.2211494,1.01530291 L10.2211494,21.1512401 Z M16.9565219,21.3669823 L11.6659819,1.91674567 L15.8971727,0.799560722 L21.1877127,20.2497974 L16.9565219,21.3669823 Z",
    id: "Shape",
    stroke: "#1717CE",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10714286,2.19310345 L1.17857143,2.19310345 C0.763616098,2.19310345 0.419047619,2.45622847 0.419047619,2.79310345 C0.419047619,3.12997843 0.763616098,3.39310345 1.17857143,3.39310345 L5.10714286,3.39310345 C5.52209819,3.39310345 5.86666667,3.12997843 5.86666667,2.79310345 C5.86666667,2.45622847 5.52209819,2.19310345 5.10714286,2.19310345 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10714286,4.72183908 L1.17857143,4.72183908 C0.763616098,4.72183908 0.419047619,4.9849641 0.419047619,5.32183908 C0.419047619,5.65871406 0.763616098,5.92183908 1.17857143,5.92183908 L5.10714286,5.92183908 C5.52209819,5.92183908 5.86666667,5.65871406 5.86666667,5.32183908 C5.86666667,4.9849641 5.52209819,4.72183908 5.10714286,4.72183908 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2142857,2.19310345 L5.5,2.19310345 C5.01506666,2.19310345 4.60952381,2.45117617 4.60952381,2.79310345 C4.60952381,3.13503073 5.01506666,3.39310345 5.5,3.39310345 L10.2142857,3.39310345 C10.6992191,3.39310345 11.1047619,3.13503073 11.1047619,2.79310345 C11.1047619,2.45117617 10.6992191,2.19310345 10.2142857,2.19310345 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2142857,4.72183908 L5.5,4.72183908 C5.01506666,4.72183908 4.60952381,4.9799118 4.60952381,5.32183908 C4.60952381,5.66376636 5.01506666,5.92183908 5.5,5.92183908 L10.2142857,5.92183908 C10.6992191,5.92183908 11.1047619,5.66376636 11.1047619,5.32183908 C11.1047619,4.9799118 10.6992191,4.72183908 10.2142857,4.72183908 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.10714286,18.7218391 L1.17857143,18.7218391 C0.763616098,18.7218391 0.419047619,18.9849641 0.419047619,19.3218391 C0.419047619,19.6587141 0.763616098,19.9218391 1.17857143,19.9218391 L5.10714286,19.9218391 C5.52209819,19.9218391 5.86666667,19.6587141 5.86666667,19.3218391 C5.86666667,18.9849641 5.52209819,18.7218391 5.10714286,18.7218391 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2142857,18.7218391 L5.5,18.7218391 C5.01506666,18.7218391 4.60952381,18.9799118 4.60952381,19.3218391 C4.60952381,19.6637664 5.01506666,19.9218391 5.5,19.9218391 L10.2142857,19.9218391 C10.6992191,19.9218391 11.1047619,19.6637664 11.1047619,19.3218391 C11.1047619,18.9799118 10.6992191,18.7218391 10.2142857,18.7218391 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1068237,2.47611292 L12.1939033,3.53204902 C11.7850503,3.6423816 11.5046,3.96377422 11.5852073,4.26674885 C11.6665335,4.57242519 12.0733547,4.71102881 12.4838955,4.60024076 L16.3968159,3.54430466 C16.8056689,3.43397208 17.0861192,3.11257946 17.0055119,2.80960483 C16.9241857,2.50392849 16.5173645,2.36532487 16.1068237,2.47611292 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2972999,17.4761129 L16.3843795,18.532049 C15.9755265,18.6423816 15.6950762,18.9637742 15.7756835,19.2667488 C15.8570096,19.5724252 16.2638309,19.7110288 16.6743717,19.6002408 L20.5872921,18.5443047 C20.9961451,18.4339721 21.2765954,18.1125795 21.1959881,17.8096048 C21.1146619,17.5039285 20.7078407,17.3653249 20.2972999,17.4761129 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1544427,4.47611292 L13.2415223,5.53204902 C12.8326694,5.6423816 12.552219,5.96377422 12.6328264,6.26674885 C12.7141525,6.57242519 13.1209738,6.71102881 13.5315145,6.60024076 L17.444435,5.54430466 C17.8532879,5.43397208 18.1337383,5.11257946 18.0531309,4.80960483 C17.9718048,4.50392849 17.5649835,4.36532487 17.1544427,4.47611292 Z",
    id: "Path"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVadeMecum);
export default __webpack_public_path__ + "static/media/ic-vade-mecum.ec86c358f8b3cb7e0a710d8d8c49e870.svg";
export { ForwardRef as ReactComponent };